import classNames from 'classnames';

import { uiSpinnerClassNames } from './class-names';
import styles from './Spinner.module.scss';
import { UiSpinnerProps } from './types';

export const UiSpinner: React.FC<UiSpinnerProps> = ({
  size = 'md',
  className,
}) => {
  return (
    <div
      className={classNames(
        styles[uiSpinnerClassNames.root],
        styles[uiSpinnerClassNames.size(size)],
        className,
      )}
      role="status"
      aria-label={'Loading spinner'}
    />
  );
};
